import { useMutation } from '@tanstack/react-query';
import { postWithoutBody } from '@/services/GlobalSerices';
import { saveBasicInfo } from '@/services/chat';
export const useSaveDetailsMutation = () => {
    return useMutation({
        mutationFn: async (data) => {
            return saveBasicInfo(data.cookie_id, data.name, data.email, data.phone);
        },
    });
};
export const useJoinLiveKitMutation = () => {
    return useMutation({
        mutationFn: () => postWithoutBody('/auth/validate-domain'),
    });
};
